document.addEventListener("click", async (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const linkId = link.getAttribute("href").slice(1);
  if (!linkId) return;

  const modal = document.querySelector(`dialog-component[data-modal-link="${CSS.escape(linkId)}"]`);
  if (!modal) return;

  event.preventDefault();

  const openDialog = link.closest("dialog-component");
  if (openDialog && openDialog !== modal) await openDialog.closeDialog();

  modal.showDialog();
});
